// settings for about page "what we stand for" section

declare var gsap: any;
declare var ScrollTrigger: any;

const whatGraphic = () => {
  const graphicItems = document.querySelectorAll('.js-graphic-item');
  if (graphicItems.length === 0) return;

  gsap.registerPlugin(ScrollTrigger);

  const sections = gsap.utils.toArray('.js-graphic-item') as HTMLElement[];
  const graphics = gsap.utils.toArray(
    '.about__what-graphic-item'
  ) as HTMLElement[];

  let activeIndex = 0;

  function setActive(index: number) {
    if (index === activeIndex) return;

    graphics.forEach((item) => item.classList.remove('active'));
    graphics[index]?.classList.add('active');

    activeIndex = index;
  }

  function buildTriggers() {
    // 🔥 HARD RESET (this prevents drift)
    ScrollTrigger.killAll(false);

    sections.forEach((section, index) => {
      ScrollTrigger.create({
        trigger: section,
        start: 'top center',
        end: 'bottom center',
        onEnter: () => setActive(index),
        onEnterBack: () => setActive(index),
        invalidateOnRefresh: true,
      });
    });

    // force full re-measure
    ScrollTrigger.refresh(true);
  }

  // initial build
  buildTriggers();

  // ---- resize: rebuild safely ----
  let resizeTimeout: number;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);

    resizeTimeout = window.setTimeout(() => {
      buildTriggers();
    }, 250);
  });

  // ---- font / image safety ----
  window.addEventListener('load', () => {
    buildTriggers();
  });
};

export default whatGraphic;
